export default __webpack_public_path__ + "static/media/commission_icon.edf1b3f8.svg";